import React from 'react';
import ListTextBlock from '../ListTextBlock';
import Title from '../Title';

const ProjectInfo = ({title, time, role, fields, description, dotPoints}) => (
    <div className="grid extra-padding-bottom">
      <div className="container">
        <div className="wrap">
          {/*title*/}
          <div className="col col-1">
            <Title heading={title} level="1"/>
          </div>
         <div className="col col-1 col-1-2--m">
          {/*Summary*/}
          <dl>
            <dt>My Role</dt> <dd>{role}</dd>
            <dt>Creative Fields</dt> <dd>{fields}</dd>
            <dt>Years</dt> <dd>{time}</dd>
          </dl>
         </div>

         <div className="col col-1 col-1-2--m">
           {/*Description or highlights*/}
           {description !== undefined
             ? <p className="extra-padding-bottom">{description}</p>
             : null
           }
           {dotPoints !== undefined
             ? <div><p className="weight-medium" style={{'font-size':'1.6rem'}}>Responsibilities</p><ListTextBlock listArray={dotPoints}/></div>
             : null
           }
         </div>
       </div>
     </div>
    </div>
);

export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/layout/portfolio/ProjectInfo.js